import { Injectable } from '@angular/core';
import { AuthService, StartupInfos_Auth } from './auth.service';
import { AuthenticatedDTO, STATUS_WORKFLOW } from 'src/app/app.models';
import { environment } from 'src/environments/environment';
import sha256 from 'crypto-js/sha256';
import { UnitOfWorkOfflineDao } from '../../daos/unitofwork-offline.dao';

@Injectable()
export class AuthOfflineService extends AuthService {
    constructor(
        private _unitOfWork: UnitOfWorkOfflineDao,
    ) {
        super();
    }

    public doAuthenticateAction(_username: string, _password: string): Promise<AuthenticatedDTO> {
        return new Promise((resolve, reject) => {
            let lsEncryptedPwd = localStorage.getItem(environment.LS_ABWORKFLOW_ENCRYPTED_PWD);
            lsEncryptedPwd = !!lsEncryptedPwd && lsEncryptedPwd != 'undefined' && lsEncryptedPwd != 'null' ? lsEncryptedPwd : '';
            const hashPwd = JSON.stringify(sha256(_password).words);
            if (lsEncryptedPwd === hashPwd) {
                const authSession = this.AuthSession;
                if (!authSession) {
                    reject('La session est invalide. Veuillez vous authentifier en mode CONNECTE');
                    return;
                }

                this.authenticationState$.next(true);
                resolve(authSession);
            } else {
                reject('Identifiant ou mot de passe incorrect');
            }
        });
    }
    public doRefreshToken(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.authenticationState$.next(true);
            resolve(true);
        });
    }

    public doRenewExpiredPassword(_newPassword: string, _confirmPassword: string): Promise<any> {
        return new Promise((resolve, reject) => resolve());
    }
    
    public doRefreshStartupInfos(): Promise<void> {
        return new Promise(async (resolve, reject) => {
            const startupInfos = new StartupInfos_Auth();

            const responses = await this._unitOfWork.responseWorkflowDao.doGetResponsesAction();
            const pausedResponses = responses.filter(r => r.STATUS_WORKFLOW == STATUS_WORKFLOW.EN_PAUSE);
            const notSyncedResponses = responses.filter(r => r.SYNCED !== undefined && r.SYNCED === false);
            startupInfos.PAUSED_RESPONSES_WORKFLOWS = pausedResponses;
            startupInfos.VARIABLES_USER = await this._unitOfWork.envVarUserDao.doGetEnvironmentVariablesUserAction();
            this.pausedResponsesWorkflow$.next(startupInfos.PAUSED_RESPONSES_WORKFLOWS);
            this.envVariables$.next(startupInfos.VARIABLES_USER);
            this.notSyncedResponsesWorkflow$.next(notSyncedResponses);
            resolve();
        });
    }

    public doVerifyPassword(_password: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let lsEncryptedPwd = localStorage.getItem(environment.LS_ABWORKFLOW_ENCRYPTED_PWD);
            lsEncryptedPwd = !!lsEncryptedPwd && lsEncryptedPwd != 'undefined' && lsEncryptedPwd != 'null' ? lsEncryptedPwd : '';
            const hashPwd = JSON.stringify(sha256(_password).words);
            resolve(lsEncryptedPwd == hashPwd);
        })
    }
}